<script setup lang="ts">
import { computed, watch } from 'vue';
import { Alert, Spin } from 'ant-design-vue';

import { useLoadIframe } from './useLoad';

const props = defineProps<{ url: string }>();
const { loading, error } = useLoadIframe(
  computed(() => props.url),
  { cache: 'force-cache' }, // the file never changes
);
const isError = defineModel<boolean>('isError');
watch(error, (newError) => {
  isError.value = !!newError;
}, { immediate: true });
</script>

<template>
  <div v-if="loading" class="flex items-center justify-center p-6">
    <Spin tip="Loading preview PDF." />
  </div>
  <Alert
    v-else-if="error"
    type="error"
    show-icon
    message="Error"
    description="Preview PDF not available."
  />
  <iframe
    v-else
    title="Renters policy coverage file"
    :src="url"
    width="100%"
    height="100%"
  />
</template>
